import { TDropDownListWithType } from '@/types';
import { ETableUrlFilters } from '@/components/table/types';

export const EMPTY_TABLE_BODY_CELL = '-';

export const SEPARATOR_URL_FILTER_VALUES = '-';
export const SORT_URL_PARAM_NAME = ETableUrlFilters.sort;
export const PER_PAGE_URL_PARAM_NAME = ETableUrlFilters.per__page;
export const PAGE_URL_PARAM_NAME = ETableUrlFilters.page;
export const DATE_URL_PARAM_NAME = ETableUrlFilters.date;

// Report builder
export const FILTERS_URL_PARAM_NAME = ETableUrlFilters.filter;
export const DIMENSIONS_URL_PARAM_NAME = ETableUrlFilters.dimensions;
export const METRICS_URL_PARAM_NAME = ETableUrlFilters.metrics;

const TABLE_FIELDS = {
  // Table columns
  impressions: 'impression',
  clicks: 'clicks',
  spend: 'spend',
  ctr: 'ctr',
  cpc: 'cpc',
  conversions: 'order',
  confirmed: 'confirmed',
  rejected: 'rejected',
  cpl: 'cpl',
  cpa: 'cpa',
  revenue: 'revenue',
  roi: 'roi',
  performance: 'performance',
  postTracking: 'post_tracking',
  timeUnit: 'time_unit',
  device: 'device',
  geography: 'geography',
  source: 'source',
  hour: 'hour',
  day: 'day',
  month: 'month',
  deviceType: 'device_type',
  operationSystem: 'operation_system',
  browser: 'browser',
  make: 'make',
  model: 'model',
  screenResolution: 'screen_resolution',
  country: 'country',
  region: 'region',
  city: 'city',
  inventoryType: 'inventory_type',
  inventorySource: 'inventory_source',
  domain: 'domain',
  categoryPage: 'category_page',
  languagePage: 'language_page',
  referrerType: 'referrer_type',
  group: 'group',
  groupId: 'group_id',
  campaignId: 'campaign_id',
  creativeId: 'creative_id',
  campaignIds: 'campaign_ids',
  creativeIds: 'creative_ids',
  geo: 'geo',
  users: 'users',
  user: 'user',
  campaignUserId: 'campaign_user_id',

  name: 'name',
  link: 'link',
  description: 'description',

  // Special
  sort: 'sort',
  fromDate: 'from_date',
  toDate: 'to_date',
  dateFilter: DATE_URL_PARAM_NAME,
  perPage: PER_PAGE_URL_PARAM_NAME,
  page: PAGE_URL_PARAM_NAME,
  filters: FILTERS_URL_PARAM_NAME,
  dimensions: DIMENSIONS_URL_PARAM_NAME,
  metrics: METRICS_URL_PARAM_NAME,
};

export const tableFieldConvert = (field: string): string => {
  return TABLE_FIELDS[field];
};

export const perPageList = (): TDropDownListWithType<number> => {
  return [
    {
      label: '20',
      value: 20,
    },
    {
      label: '50',
      value: 50,
    },
    {
      label: '100',
      value: 100,
    },
  ];
};

export const defaultPerPage = (): number => {
  return perPageList()[0].value;
};

export const toolPanelDefault = (): Array<string> => {
  return ['totalRow', 'perPage', 'optionalColumns'];
};
